<template>
  <div class="calendar" :class="type == 1?'systemCalendar':'newCalendarAgain'">
    <input id="nowDate" :value="nowDate" style="display:none;"/>
    <button  v-if="type == 0" id="refreshButton" @click="loadScheduleData()">刷新</button>
    <p v-if="type == 1" style="color: #212121;font-size: 22px;padding: 5px;margin: 0">我的课表</p>
    <p style="text-align: center;color: #F6141F;font-size: 18px;margin: 0;font-weight: bold">{{nowMonth}}月</p>
    <a-calendar
      :fullscreen='false'
      mode="month"
      @panelChange="onPanelChange"
      @select="onSelect"
    >
      <template slot="dateCellRender" slot-scope="value">
          <!--{{daysJson[getDateFormat(value)]!=null?daysJson[getDateFormat(value)].num:''}}-->
          <!--<div class="calendarMark" v-show="daysJson[getDateFormat(value)]!=null">-->
          <div class="calendarMark" v-if="(daysJson[getDateFormat(value)]!=null?daysJson[getDateFormat(value)].num:0)>0">
              <div >
                  {{daysJson[getDateFormat(value)]!=null?daysJson[getDateFormat(value)].num:0}}
              </div>
              <!--<img :src="markImg">-->
          </div>
      </template>
    </a-calendar>
    <div v-if="type == 1">
        <p class="item_title">9月17日课程安排</p>
        <div style="padding: 0 0 10px 0">
            <div class="item_curriculum" v-for="(item,index) in curriculumInfo" :key="index" :class="item.type==0?'curriculum_style_a':'curriculum_style_b'">
                <div class="item_left">
                    <p class="item_left_title">{{item.name}}</p>
                    <p class="item_left_text">{{item.text1}}</p>
                    <p class="item_left_text">{{item.text2}}</p>
                </div>
                <button v-if="item.type==0" class="curriculum_btn_a">进入直播</button>
                <button v-if="item.type==1" class="curriculum_btn_b">课程评价</button>
            </div>
        </div>
    </div>
    <div >
      <el-card v-for="(scheduleOne,index) in nowDaySchedule" :key="index" >
          <div class="new_el_card">
              <div>
                  <div>
                      {{scheduleOne.COURSE_NAME}}
                  </div>
                  <div>
                      {{scheduleOne.TEA_NAME}}
                  </div>
                  <div>
                      {{scheduleOne.STU_NAME}}
                  </div>
              </div>
              <div v-if="pageSet" class="new_el_card_right">
                  <el-dropdown v-if="pageSet.operaButtonSet.length > 1"
                               trigger="click" size="mini"
                               @command="dataButtonSetClick($event,scheduleOne)"
                  >
                      <el-button type="primary"
                                 size="mini"
                      >
                          操作<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-for="(operaButtonOne,operaButtonIndex) in pageSet.operaButtonSet" :key="operaButtonIndex"
                                            v-if="operaButtonOne.ifShow && (scheduleOne[operaButtonOne.butTjKey] != 0)"
                                            :command="operaButtonOne"
                          >
                              {{operaButtonOne.buttonName}}
                          </el-dropdown-item>

                      </el-dropdown-menu>
                  </el-dropdown>
                  <el-button-group v-else>
                      <el-button v-for="(operaButtonOne,operaButtonIndex) in pageSet.operaButtonSet" :key="operaButtonIndex"
                                 v-if="operaButtonOne.ifShow"
                                 @click="dataButtonSetClick(operaButtonOne,scheduleOne)" type="text" size="small"
                      >
                          {{operaButtonOne.buttonName}}
                      </el-button>
                  </el-button-group>
              </div>
          </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
//moment.locale('zh-cn');

import utils from '@/js/page/pageUtil.js'
// import { Calendar } from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.css'
export default {
  name: 'Schedule',
  props: {
    initPageSet: Object,
    initTableId: {
      type:Number,
      default:0
    },
    initPageId: {
      type:Number,
      default:0
    },
    type: {
      type:Number,
      default:0
    }
  },
  data() {
    return {
      //系统小程序设置 课表的tableId和pageId
      sysSetInfo:{},
      nowYear:null,
      //当前的选中月份
      nowMonth:null,
      nowDate:null,
      daysJson:{},
      nowDaySchedule:[],
      pageSet:null,
      tableId:0,
      pageId:0,
      markImg:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABACAYAAABFqxrgAAABu0lEQVR4Xu3Z3VXCQBAF4Ds0AKWEDqQTS7ACE6mADjxWoiVYCjTAeIImLpsfshty2J/LGw885MvMvSEr4AdCAxChHgJOAhF+w4CTQAROQluMXAeuA9eB62A+KTMTmAnMBGYCM8F6f8BgZDAyGBmMDEYGY/fVMtuB7cB2YDuwHdgObIcrAa2wkQrHbCuyBoDgU0pss0RoACBSyKtKdggmwOUcMjcEGyA7hD6ArBCGALJBGAPIAuEWQPIIUwCSRpgKkCyCC0CSCK4AySH4ACSF4AuQDMIcgCQQ5gJEj+AOoCcALwAOgKybtyvR/ov0AjjjSSp8a4UCK3w1EFEizAFo7r6+oYJIGeU63AVgj2dA3qNchyUAopqEpQCiQVgSIAqEXgDVDygOZsL/HyboCX8t0IaglQH20UvQ7TAEIGUdbIBddYA7QNCTMLgCZ93WXd/e5bbzAdcJCLodRjNA9QjFrgNRnx+YODdW4OpEOrRzh0kh2ANhXpQ6AAS3DpMA2j3oTsQlJxwBgkJwAhiA8AEIBsELwILACoX5KGzX4Nj3h1fkLAATQmTjcuHBBONdAHyv3PjdwyYhFIAmE34AKToGUA46JMgAAAAASUVORK5CYII=',
      curriculumInfo:[{name:'基础资料讲解',text1:'上课时间 9:00-11:00',text2:'上课时间 9:00-11:00',type:'0'},{name:'基础资料讲解',text1:'上课时间 9:00-11:00',text2:'上课时间 9:00-11:00',type:'1'}]
    }
  },
  created() {
    this.pageSet = this.initPageSet;
    this.tableId = this.initTableId;
    this.pageId = this.initPageId;
  },
  mounted() {
    var nowDate = new Date();
    var nowYear = nowDate.getFullYear();
    console.log("nowYear=============", nowYear);
    var nowMonth = nowDate.getMonth() + 1;
    var nowDay = nowDate.getDate();
    this.nowYear = nowYear*1;
    this.nowMonth = nowMonth*1;
    this.nowDate = utils.dateFormat(nowDate,'yyyy-MM-dd');
    if(this.pageSet) {
      this.loadScheduleData();
    } else {
      this.getSysSet();
    }
  },
  components: {
  },
  methods: {
    onPanelChange(date){
      console.log("date-----111----------",date.format("YYYY-MM-DD"));
      this.nowYear = date.format("YYYY")*1;
      this.nowMonth = date.format("MM")*1;
      this.nowDate = date.format("YYYY-MM-DD");
      this.loadScheduleData();
    },
    /**
     * 当日期选中时触发
     */
    onSelect(date) {
      console.log("date---------------",date.format("YYYY-MM-DD"));
      this.nowDate = date.format("YYYY-MM-DD");
      this.clickDay(date.format("YYYY-MM-DD"));
    },
    /**
     * 列表按钮点击时 执行
     */
    dataButtonSetClick(operaButtonOne,rowData) {

    },
    /**
     * 日期字段转为 字符 yyyy-MM-dd
     */
    getDateFormat(value) {
      return value.format("YYYY-MM-DD");
    },
    /**
     * 根据选中的天 进行显示数据的变更
     */
    clickDay(date){
      console.log("点击================",date);
      var daysJson = this.daysJson;
      var nowDayScheduleJson = daysJson[date];
      var nowDaySchedule = [];
      console.log("nowDayScheduleJson================",daysJson,date,nowDayScheduleJson);
      if (nowDayScheduleJson) {
        this.nowDaySchedule = nowDayScheduleJson.scheduleArr;
      } else {
        this.nowDaySchedule = [];
      }
    },
    /**
     * 获取系统设置信息
     */
    getSysSet(){
      var that = this;
      var url = "/model_getSysSet.do";
      var toHtData = {};
      toHtData.tableName = "XCX_SYS_SET";
      toHtData.proId = that.proId;
      this.$axios.post(url,toHtData).then(res => {
        if (res.data) {
          var sysSetInfo = res.data.XCX_SYS_SET;
          that.sysSetInfo = sysSetInfo;
          var tableId = sysSetInfo.KB_TABLE_ID;
          var pageId = sysSetInfo.KB_PAGE_ID;
          that.tableId = tableId;
          that.pageId = pageId;
          that.zdyMounted();
        } else {
          alert("没有获取到相关设置信息,请联系管理员2");
        }
      }).catch(error => {
        console.log("=====" + error);
        alert("没有获取到相关设置信息,请联系管理员1");
      })
    },
    zdyMounted(){
      var that = this;
      //去后台请求本套试卷的信息
      that.loadScheduleData();
    },
    /**
      * 加载当前显示月的数据
      */
    loadScheduleData:function(){
        var that = this;
        var nowYear = that.nowYear;
        var nowMonth = that.nowMonth;

        var tableId = that.tableId;
        var pageId = that.pageId;
        if(pageId > 0 && tableId > 0) {
            that.loading = true;
            var toHtData = {};
            //tableId 表id
            toHtData.tableId = tableId;
            //pageId 页面id
            toHtData.pageId = pageId;

            toHtData.START_DATE_3_andOr = 0;
            toHtData.START_DATE_dateType = 'yyyy-MM'
            toHtData.START_DATE_startDates_pld = nowYear + "-" + ((nowMonth < 10) ? '0' + nowMonth : nowMonth);
            toHtData.START_DATE_endDates_pld = nowYear + "-" + ((nowMonth < 10) ? '0' + nowMonth : nowMonth);

            //传递到后台用于搜索的参数
            //分页信息 
            toHtData.start = 0;
            toHtData.limit = 1000 + "_flow";

            toHtData.ifAjaxCount = true;
            //isOnlyCount  是否只查询记录数
            toHtData.isOnlyCount = false;

            var url = 'model_ajaxList.do?source=1';

            this.$axios.post(url,toHtData).then(res => {
                that.loading = false;
                var scheduleRows = res.data.rows;
                var daysJson = {};
                for (var i = 0; i < scheduleRows.length; i++) {
                  var startTime = scheduleRows[i].START_TIME;
                  var endTime = scheduleRows[i].END_TIME;
                  scheduleRows[i].START_END_TIME = startTime + "-" + endTime.substring(11);
                  var showInfo = scheduleRows[i].SHOW_INFO;
                  if (showInfo) {
                    var showInfoArr = showInfo.split(",");
                    scheduleRows[i].COURSE_NAME = showInfoArr[0];
                    scheduleRows[i].TEA_NAME = showInfoArr[1];
                    scheduleRows[i].STU_NAME = showInfoArr[2];
                  }
                  startTime = startTime.replace(/-/g, '/');
                  var startDate = new Date(startTime);
                  var oneDate = utils.dateFormat(startDate,'yyyy-MM-dd');
                  if(!daysJson[oneDate]) {
                    daysJson[oneDate] = {scheduleArr:[]};
                  }
                  var oneDayJson = daysJson[oneDate];
                  oneDayJson.scheduleArr.push(scheduleRows[i]);
                  oneDayJson.num = oneDayJson.scheduleArr.length;
                }
                console.log("daysJson===================",daysJson);
                that.daysJson = daysJson;
                that.clickDay(that.nowDate);
            }).catch(error => {
                that.loading = false;
                console.log("服务器异常!",error);
            });
        } else{
            console.log("没有加载信息!");
        }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
<style>
    .calendarMark{height: 100%;display: flex;align-items: center;justify-content: center}
    .calendarMark div{background-color: #FF8201;color: #ffffff;width: 20px;height:20px;border-radius: 10px;text-align: center;font-size: 12px}

    .newCalendarAgain .ant-fullcalendar-fullscreen .ant-fullcalendar-content{height: 52px !important;}
    .newCalendarAgain .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date{height: 80px !important;}
    .newCalendarAgain .ant-fullcalendar{font-size: 16px}
    .newCalendarAgain .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{border-color: #FF8201 !important;box-shadow: 0 0 3px 0 #FF8201 !important;}
    .newCalendarAgain .ant-radio-button-wrapper:hover, .ant-radio-button-wrapper-focused{color: #FF8201}
    .newCalendarAgain .ant-radio-button-wrapper-checked:hover{border-color: #FF8201;box-shadow: -1px 0 0 0 #FF8201;color: #FF8201}
    .newCalendarAgain .ant-radio-button-wrapper-checked{border-color: #FF8201;box-shadow: -1px 0 0 0 #FF8201;}
    .newCalendarAgain .ant-radio-button-wrapper-checked{color: #FF8201}
    .newCalendarAgain .ant-radio-button-wrapper-checked:first-child{border-color: #FF8201}
    .newCalendarAgain .ant-select-selection:hover{border-color: #FF8201}
    .newCalendarAgain .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value, .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value{color: #FF8201 !important;}
    .newCalendarAgain .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date{border-top-color: #FF8201 !important;}
    .newCalendarAgain .ant-fullcalendar-column-header{line-height: 30px;color: #fff;}
    .newCalendarAgain table thead tr{background-color: #FF8201}
    .newCalendarAgain .el-card:hover{border-color: #FF8201}
    .new_el_card{display: flex;justify-content: space-between}
    .new_el_card_right{display: flex;align-items: center;}
    .new_el_card_right .el-button--primary{background-color: #FF8201;border-color: #FF8201;}

    .systemCalendar{background: #ffffff;margin-left: 10px}
    .systemCalendar .ant-fullcalendar-fullscreen .ant-fullcalendar-content{height: 52px !important;}
    .systemCalendar .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date{height: 80px !important;}
    .systemCalendar .ant-fullcalendar{font-size: 16px}
    .systemCalendar .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{border-color: #FF8201 !important;box-shadow: 0 0 3px 0 #FF8201 !important;}
    .systemCalendar .ant-radio-button-wrapper:hover, .ant-radio-button-wrapper-focused{color: #FF8201}
    .systemCalendar .ant-radio-button-wrapper-checked:hover{border-color: #FF8201;box-shadow: -1px 0 0 0 #FF8201;color: #FF8201}
    .systemCalendar .ant-radio-button-wrapper-checked{border-color: #FF8201;box-shadow: -1px 0 0 0 #FF8201;}
    .systemCalendar .ant-radio-button-wrapper-checked{color: #FF8201}
    .systemCalendar .ant-radio-button-wrapper-checked:first-child{border-color: #FF8201}
    .systemCalendar .ant-select-selection:hover{border-color: #FF8201}
    .systemCalendar .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value, .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value{color: #FF8201 !important;}
    .systemCalendar .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date{border-top-color: #FF8201 !important;}
    .systemCalendar .ant-fullcalendar-column-header{line-height: 30px;color: #1e1e1e;}
    .systemCalendar table thead tr{background-color: #ffffff}
    .systemCalendar .el-card:hover{border-color: #FF8201}

    .systemCalendar .ant-fullcalendar-selected-day .ant-fullcalendar-value, .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value{background: #FE4974;color: #fff}
    .systemCalendar .ant-fullcalendar-today .ant-fullcalendar-value, .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value{box-shadow: 0 0 0 1px #FE4974 inset}
    .systemCalendar .ant-fullcalendar-value{border-radius: 24px}

    .item_title{text-align: center;font-size: 18px;color: #383838;border-top: 1px solid #EDEDED;padding: 10px;margin: 10px}
    .item_curriculum{display: flex;justify-content: space-between;align-items: center;margin: 10px 20px;padding: 10px 20px}
    .item_left_title{font-size: 15px;color: #6F6B68;margin-bottom: 5px}
    .item_left_text{font-size: 13px;color: #8C8C8C;margin: 0}
    .curriculum_btn_a,.curriculum_btn_b{text-align: center;height: 26px;width: 75px;line-height: 26px;padding: 0;border: none;border-radius: 12px}
    .curriculum_btn_a{background: #FBBF00;color: #AB7D00}
    .curriculum_btn_b{background: #E4E4E4;color: #808080}

    .curriculum_style_a{border-left: 5px solid #FFBC03;background: #FFF9EF}
    .curriculum_style_b{border-left: 5px solid #E3E3E3;background: #F7F7F7}

</style>
